import { useTranslation } from 'react-i18next';

import type { CollectionKind } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<CollectionKind, string> = {
  manual: 'bg-secondary text-secondary-foreground border-transparent',
  automated: 'bg-primary/10 text-primary border-transparent dark:bg-primary/20',
};

export function CollectionKindBadge({
  kind,
  className,
}: {
  kind: CollectionKind;
  className?: string;
}) {
  const { t } = useTranslation('collections');
  return (
    <Badge variant="outline" className={cn(STYLES[kind], className)}>
      {t(`kind.${kind}`)}
    </Badge>
  );
}
